require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-sian-teasdale.json") })
        }
      }, "path---authors-sian-teasdale");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-sian-teasdale!./.cache/json/authors-sian-teasdale.json
// module id = 1339
// module chunks = 231608221292675